import { FormEvent } from "react";
import classNames from "classnames";
import { AddressElement, CardElement } from "@stripe/react-stripe-js";

import styles from "./AscAddPaymentMethod.module.scss";
import AscButton from "../AscButton/AscButton";

export interface AscAddPaymentMethodProps {
  className?: string;
  onCancel: () => void;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  disableSaveAction: boolean;
}

const CARD_OPTIONS = {
  hidePostalCode: true,
  style: {
    base: {
      fontSize: "16px",
    },
    focus: {
      boxShadow: "none",
    },
  },
};

export default function AscAddPaymentMethod({
  className,
  onCancel,
  onSubmit,
  disableSaveAction,
}: AscAddPaymentMethodProps) {
  return (
    <form
      data-testid="asc-add-payment-method"
      className={classNames(styles.ground, className)}
      onSubmit={onSubmit}
    >
      <CardElement options={CARD_OPTIONS} />
      <br />
      <AddressElement options={{ mode: "billing" }} />
      <div className={styles.groundFooter}>
        <AscButton type="button" variant="secondary" onClick={onCancel}>
          Cancel
        </AscButton>
        <AscButton loading={disableSaveAction} type="submit">
          Save
        </AscButton>
      </div>
    </form>
  );
}
